import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';
import { ButtonV2 } from '@zola/zola-ui';

import './CropModal.less';

// TODO: should add minWidth and minHeight to stop crop box from being made smaller than the
// minimum width or height requirements (approximately 1200x1200)

class CropModal extends Component {
  constructor(props) {
    super(props);
    const aspectRatio = props.aspectRatio || 1280 / 700;
    this.state = {
      // crop values in percentage form
      crop: {
        aspect: aspectRatio, // aspect ratio of crop based on %width/%height
        // omit height to fix aspect ratio - from react-image-crop docs
        width: 100, // crop width based on percentage of image width
        x: 0, // crop x-coordinate based on percentage of image width
        y: 0, // crop y-coordinate based on percentage of image width
      },
      // crop values in pixel form - this is what we will eventually pass to our callback
      // these are all initialized to 0 and the actaul values will be set by handleImageUpload
      pixelCrop: {
        height: 0, // crop height in pixels,
        width: 0, // crop width in pixels
        x: 0, // crop x-coordinate in pixels
        y: 0, // crop y-coordinate in pixels
      },
      imgLoaded: false,
      submitted: false,
    };

    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleImageLoaded(img, pixelCrop) {
    // pixelCrop needs to be set so that we have the width/height of the image in
    // in pixels, since we don't know these values until the image has loaded
    this.setState({
      pixelCrop,
      imgLoaded: true,
    });
  }

  handleCrop(crop, pixelCrop) {
    this.setState({
      crop, // update the crop object which is used by ReactCrop
      pixelCrop, // update the pixelCrop object which will be used by onCropSelect callback in handleSubmit
    });
  }

  handleSubmit() {
    const { onCropSelect } = this.props;
    const { pixelCrop } = this.state;
    // set submitted state to true to disable submit button, so that it cannot be clicked again while saving cropped image
    this.setState({ submitted: true }, () => onCropSelect(pixelCrop));
  }

  render() {
    const { imageUrl, minimal, subcopy } = this.props;
    const { imgLoaded, crop, submitted } = this.state;

    return (
      <div id={minimal ? 'cropper' : 'crop-modal'}>
        {!minimal && (
          <div className="modal-header">
            <h3 className="modal-title">Crop Photo</h3>
            {subcopy && <p className="margin-top">{subcopy}</p>}
          </div>
        )}
        <div className={minimal ? 'cropper' : 'modal-body'}>
          <div className="crop-wrapper">
            <ReactCrop
              src={imageUrl}
              onComplete={this.handleCrop}
              onImageLoaded={this.handleImageLoaded}
              crop={crop}
              keepSelection
              onChange={this.handleCrop}
            />
          </div>
          <div className="save-crop">
            <ButtonV2 onClick={this.handleSubmit} disabled={submitted || !imgLoaded}>
              {submitted ? 'Uploading...' : 'Save'}
            </ButtonV2>
          </div>
        </div>
      </div>
    );
  }
}

CropModal.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onCropSelect: PropTypes.func.isRequired,
  aspectRatio: PropTypes.number,
  minimal: PropTypes.bool,
  subcopy: PropTypes.string,
};

export default CropModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/CropModal/CropModal.jsx